export const BalanceKeys = {
    all: ['balance'] as const,
    school: (id:number) => [...BalanceKeys.all, 'school', `${id}`] as const,
};